import { createAction, props } from '@ngrx/store';
import { ILocationContext } from '../../../../model/location-context';
import { IStatistic } from '../../../../model/statistics';

// Links
export const requestStatistics = createAction(
    '[Statistics] Request Statistics',
    props<{ locationContext: ILocationContext }>()
);

export const loadStatistics = createAction('[Statistics] Load Statistics', props<{ statistics: IStatistic[] }>());
